<template>
  <div class="documentArea">
    <div class="white-bg borderRadius p40 pt20" v-loading="loading">
      <div class="flex al-cn ju-sp ptb20 borderBottom" v-for="(item,index) in list" :key="index">
        <div class="flex al-cn documentArea-left">
          <div class=""></div>
          <div class="font-bold cl000 f16">{{ item.title }}</div>
        </div>
        <div class="">
          <el-button type="success" round size="small" @click="downloadCourse(item)">下载资源</el-button>
        </div>
      </div>
      <div class="flex ju-cn mt15">
        <pagination
            v-show="total > 0"
            :total="total"
            layout="prev, pager, next"
            :page.sync="queryParams.page"
            :pagesize.sync="queryParams.pagesize"
            @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {getdocumentlist} from "@/api/api";

export default {
  name: "index",
  data() {
    return {
      loading: false,
      // 总条数
      total: 2,
      // 表格数据
      list: [],
      queryParams: {
        page: 1,
        pagesize: 10,
      },
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 获取全部发布信息
    getList() {
      if (this.loading) return
      this.loading = true;
      getdocumentlist(this.queryParams).then(response => {
        if (response.code === 200) {
          this.list = response.data.data;
          this.total = response.data.total;
        }
        this.loading = false;
      });
    },
    // 下载课程资源
    downloadCourse(e) {
      window.open(e.fileurl)
    }
  }
}
</script>


<style scoped lang="scss">
.documentArea {
  &-left {
    width: 87%;
  }
}

@media screen and (max-width: 750px) {
  .documentArea {
    &-left {
      width: 70%;
    }
  }
}
</style>
